import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import normalizeOrgChart from './normalizeOrgChart';

export default function dashboardContextReducer(state = initialState.dashboardContext, action) {
	switch (action.type) {
		case types.UPDATE_DISPLAY_DATA: {
			if (action && action.engagements) {
				let _state = {...state};

				_state.engagements = [...new Set([...action.engagements])];
				_state.entities = _.cloneDeep(action.entities);
				_state.orgChart = normalizeOrgChart(_state.orgChart, action);

				return _state;
			}
			return state;
		}
		case types.UPDATE_TREE_ORG: {
			if (action && action.treeOrgChart) {
				let _stateOrg = {...state};
				_stateOrg.orgChart = [...action.treeOrgChart];

				return _stateOrg;
			}

			return state;
		}
		default:
			return state;
	}
}
